import { getDataBasicData, getApiCommonData, getAssetsCountries } from './api'

export const getBasicData = async (data, token) => {
  const obj = {}

  const res = await getDataBasicData(obj, token)
    .then((resp) => ({
      result: 200,
      data: {
        commonInfo: {
          language: resp['common-data']?.language || {},
          teachingMode: resp['common-data']?.teaching_mode || {},
          classGoal: resp['common-data']?.class_goal || {},
          classIntroType: resp['common-data']?.class_intro_type || {},
          reservationType: resp['common-data']?.reservation_type || {},
          reservationEnglishType: resp['common-data']?.reservation_type_english || {},
          teachingPeriod: {
            byWeek: resp['common-data']?.teaching_period?.by_week || {},
            byDay: resp['common-data']?.teaching_period?.by_day || {}
          },
          newsType: resp['common-data']?.news_type || {},
          tuitionType: resp['common-data']?.tuition || {},
          faqType: resp['common-data']?.qa_type || {},
          innerResourceType: resp['common-data']?.inner_resource_type || {},
          resourceLevel: resp['common-data']?.resource_level || {},
          assetsFlagType: resp['common-data']?.assets_flag_type || {}
        },
        contactInfo: {
          notice: resp.contact?.[0]?.notice?.split('\n') || [],
          email: resp.contact?.[0]?.email || '',
          telephone: resp.contact?.[0]?.telephone_number || '',
          address: resp.contact?.[0]?.address || '',
          openingHours: resp.contact?.[0]?.opening_hours || '',
          googleMap: resp.contact?.[0]?.google_map || '',
          line: resp.contact?.[0]?.line || '',
          facebook: resp.contact?.[0]?.facebook || '',
          youtube: resp.contact?.[0]?.youtube || ''
        },
        mediaInfo: resp['social-media']?.map((item) => ({
          index: item.index || 0,
          name: item.name,
          imageUrl: item.image_url,
          imageLink: item.image_link
        }))
      }
    }))
    .catch((err) => ({
      result: err.response?.status || -1,
      message: err.message
    }))

  return res
}

export const getApiCommon = async (data, token) => {
  const obj = {}

  const res = await getApiCommonData(obj, token)
    .then((resp) => ({
      result: 200,
      data: resp
    }))
    .catch((err) => ({
      result: err.response?.status || -1,
      message: err.message
    }))

  return res
}

export const viewCountries = async (data, token) => {
  const obj = {}

  const res = await getAssetsCountries(obj, token)
    .then((resp) => ({
      result: 200,
      data: resp.map((item) => ({
        label: `${item.chinese_name} ${item.english_name}`,
        value: item.iso_code
      }))
    }))
    .catch((err) => ({
      result: err.response?.status || -1,
      message: err.message
    }))

  return res
}
